import { RedirectRule } from './component'

export default RedirectRule
